<template>
  <b-container fluid class="mb-5" style="background: #f6f6f6;">
    <b-row align-h="center" align-v="center">
      <!-- Left Column: Image -->
      <b-col lg="6" class="px-0">
        <b-img :src="require('@/assets/logo.jpg')" fluid alt="Company Logo" />

      </b-col>

      <!-- Right Column: Content -->
      <b-col lg="6" class="py-5 py-lg-0 px-3 px-lg-5">
        <h5 class="text-primary color-bar  mb-3">About Us</h5>
        <h1 class="mb-5">15 Years Experience</h1>
        <p>
          Labore vero lorem eos sed aliquy ipsum aliquy sed. Vero dolore dolore takima ipsum lorem rebum
        </p>

        <!-- Features Row -->
        <b-row class="py-2">
          <b-col sm="6" class="text-center text-sm-left">
            <b-icon icon="patch-check" font-scale="4" class="mb-2 text-warning color-bar" />
            <h5 class="mt-2">Govt Approved</h5>
            <p>Ipsum sanctu dolor ipsum dolore sit et kasd duo</p>
          </b-col>

          <b-col sm="6" class="text-center text-sm-left">
            <b-icon icon="award" font-scale="4" class="mb-2 text-warning color-bar" />
            <h5 class="mt-2">Award Winning</h5>
            <p>Ipsum sanctu dolor ipsum dolore sit et kasd duo</p>
          </b-col>
        </b-row>

        <!-- Button -->
        <b-button variant="warning" size="lg" class="px-4 button-color">Learn More</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "ExperiencePage",
};
</script>

<style scoped>
h1 {
  font-weight: bold;
}
.color-bar{
  color: #990000 !important;
}
.button-color{
  background-color: #990000 !important;
  color: #ffff;
}
.button-color:hover{
  background-color: #4D4D4D !important;
  color: #ffff;
}
</style>
